import { AbstractControl } from '@angular/forms';

export function toFormData(control: AbstractControl | Record<string, unknown>) {
  const form = new FormData();

  if (control instanceof AbstractControl) {
    control = control.value;
  }

  Object.entries(control)
    .forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value = value.join('');
      }

      form.append(key, value as string);
    });

  return form;
}

export function removeNullable(obj: Record<string, any>): object {
  return Object.entries(obj)
    .filter(([_, value]) => (
      typeof value === 'boolean' ? true :
        typeof value === 'string' ? !!value.trim().length :
          Array.isArray(value) ? !!value.length : value
    ))
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
}

export function base64ToBlob(base64: string, mimeType: string = 'image/png') {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
}

export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function emptyStringAsNull(obj: Record<string, any>): object {
  return Object.fromEntries(
    Object.entries(obj)
      .map(([key, value]) => [key, typeof value !== 'string' || (
        typeof value === 'string' &&
        value.trim().length
      ) ? value : null])
  );
}

export function generateGUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
